module.exports = __webpack_public_path__ + "first-20_glossy_stripe.jpg?fd334f6614c88cca33ab000f0619463b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20_glossy_stripe.jpg
// module id = 498
// module chunks = 0